import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Login from '../components/auth/Login';
import RegisterForm from '../components/auth/RegisterForm';
import AccountActivationPage from '../components/auth/AccountActivationPage/AccountActivationPage';
import PostRegisterPage from '../components/auth/PostRegisterPage/PostRegisterPage';
import ResetPasswordPage from '../components/auth/ResetPasswordPage/ResetPasswordPage';
import ForgotPasswordPage from '../components/auth/ForgotPasswordPage/ForgotPasswordPage';
import PostResetTriggerPage from '../components/auth/PostResetTriggerPage/PostResetTriggerPage';
import ImpressumPage from '../components/InfoPages/ImpressumPage';
import CookiePolicyPage from '../components/Cookies/Cookies';
import PrivacyPolicyPage from '../components/InfoPages/PrivacyPolicyPage';
import LandingPage from '../components/LandingPage';
import NotificationPage from '../components/notifications';
import ConnectMapDevices from '../components/DeviceManager/Group/Overview/MapDevices/MapDevices';
import UserProfile from '../components/users/Profile/UserProfile/UserProfile';
import ConnectRecipeManager from '../components/recipeManager/RecipeManagerPage';
import ConnectRecipeManagerExport from '../components/recipeManager/export/RecipeManagerExport';
import ConnectCreationVoucher from '../components/vouchers/CreationVoucher/CreationVoucher';
import ExtendedRoutes from '../util/route-dom/ExtendRoutes/ExtendRoutes';
import AppLayout from '../App/AppLayout';
import StoerkIdRoutes from './StoerkIdRoutes';
import DeviceManagerRoutes from './DeviceManagerRoutes';
import AuthGuard from '../components/auth/AuthGuard/AuthGuard';
import AppRedirect from '../App/AppRedirect';
import InfoPagesLayout from '../components/InfoPages/InfoPagesLayout';
import IncidentDetailsPage from '../components/Incident/IncidentDetailsPage';
import IncidentListPage from '../components/Incident/IncidentListPage/IncidentListPage';
import { useAppSelector } from '../redux/store.model';
import showAlarmsSelector from '../redux/incident/selectors/showAlarmsSelector';
import TermsAndConditionsPage from '../components/InfoPages/TermsAndConditionsPage/TermsAndConditionsPage';
import DashboardPage from '../components/Dashboard/DashboardPage';
import MerchandiserRoutes from '../customized/fresh-watch/components/Merchandiser/MerchandiserRoutes';
import OperatorDashboard from '../customized/fresh-watch/components/Dashboard/Operator/OperatorDashboard';
import GroupManagerLayoutItem from '../components/DeviceManager/Group';
import ReportsMainPage from '../customized/fresh-watch/components/Dashboard/RegionalManager/Reports/ReportsMainPage';
import ReportsDetailPage from '../customized/fresh-watch/components/Dashboard/RegionalManager/Reports/ReportsDetail/ReportsDetailPage';
import MerchandisersPage from '../customized/fresh-watch/components/MerchandisersPage/MerchandisersPage';
import InvitationsAdministrator from '../customized/fresh-watch/components/Invitations/InvitationsAdministrator';
import InvitationsGuard from '../customized/fresh-watch/guards/InvitationsGuard';
import RolesGuard from '../components/auth/RolesGuard';
import { ValidateEmail } from '../customized/fresh-watch/components/auth/RegisterForm/ValidateEmail';

function RoutesWrap() {
  const showAlarms = useAppSelector(showAlarmsSelector);
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<AppRedirect />} />

        <Route path="/landing-page" element={<LandingPage />} />
        <Route element={<InfoPagesLayout />}>
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/cookies" element={<CookiePolicyPage />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditionsPage />}
          />
        </Route>
      </Route>
      <Route element={<AppLayout showHeader={false} />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register/:workspaceId" element={<ValidateEmail />}>
          <Route path="validate-email" element={<ValidateEmail />} />
        </Route>
        <Route path="/register" element={<RegisterForm />} />
        <Route path="/signup" element={<RegisterForm />} />
        <Route path="/registered" element={<PostRegisterPage />} />
        <Route path="/activate" element={<AccountActivationPage />} />
        <Route path="/resetpassword" element={<ResetPasswordPage />} />
        <Route path="/resettriggered" element={<PostResetTriggerPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      </Route>
      <Route element={<AuthGuard />}>
        <Route element={<AppLayout />}>
          <Route path={'/account/*'} element={<StoerkIdRoutes />} />
          <Route element={<GroupManagerLayoutItem />}>
            <Route path="/dashboard">
              <Route index element={<DashboardPage />} />
              <Route
                path="merchandiser/:merchandiserId/*"
                element={<MerchandiserRoutes />}
              />
              <Route path="store/:groupId">
                <Route index element={<OperatorDashboard />} />
                <Route
                  path="merchandiser/:merchandiserId/*"
                  element={<MerchandiserRoutes />}
                />
              </Route>
              <Route path="reports">
                <Route index element={<ReportsMainPage />} />
                <Route path="detail/:cityId" element={<ReportsDetailPage />} />
              </Route>
            </Route>
          </Route>
          <Route
            path="/merchandiser/:merchandiserId/*"
            element={<MerchandisersPage />}
          />
          <Route element={<RolesGuard />}>
            <Route path="/companies/*" element={<DeviceManagerRoutes />} />
            <Route path="/storelist/*" element={<DeviceManagerRoutes />} />
          </Route>
          <Route path="/devicemanager/*" element={<DeviceManagerRoutes />} />

          <Route path="/map" element={<ConnectMapDevices />} />
          <Route
            path="/recipemanager/group/:groupId"
            element={<ConnectRecipeManager />}
          />
          <Route
            path="/recipemanager/export/group/:groupId"
            element={<ConnectRecipeManagerExport />}
          />
          <Route path="/userprofile" element={<UserProfile />} />
          <Route path="/notifications" element={<NotificationPage />} />
          {showAlarms && (
            <Route path="/alarms" element={<IncidentListPage />} />
          )}
          {showAlarms && (
            <>
              <Route path="/alarm/:alarmId" element={<IncidentDetailsPage />} />
              <Route
                path="/alarms/:alarmId"
                element={<IncidentDetailsPage />}
              />
            </>
          )}
          <Route path="/createvoucher" element={<ConnectCreationVoucher />} />
          <Route element={<InvitationsGuard />}>
            <Route path="/invitations" element={<InvitationsAdministrator />} />
          </Route>
          <Route path="*" element={<ExtendedRoutes />} />
        </Route>
      </Route>
    </Routes>
  );
}

export default RoutesWrap;
